import isEmpty from 'lodash/isEmpty';
import { Text } from '@querodelivery/uni-react';
import { Pagination } from '@quero-delivery/quero-components-web';
import JsonView from '@/Shared/JsonView';
import styles from './styles.module.scss';
import type { DeliveryListProps } from './types';
import { TableSkeleton } from '@/_components/skeletons/table-skeleton/table-skeleton';
import { Table, useStackedTableLayout } from '@/_components/table';
import type { Delivery } from '../../types';
import DeliveryRow from '@/features/deliveryTable/DeliveryRow';
import { DEFAULT_LIMIT_REQUEST, MediaQueryMobile } from '@/Constants';
import { DELIVERIES_TABLE_GRID_COLUMNS } from '@/features/deliveryTable/constants';
import { TableEmptyState } from '@/_components/table-empty-state/table-empty-state';

export function DeliveriesList({
  page,
  setPage,
  isLoading,
  data,
}: DeliveryListProps) {
  const isStackedTableLayout = useStackedTableLayout({
    customQuery: MediaQueryMobile,
  });

  const renderDeliveryRow = (delivery: Delivery) => {
    return (
      <DeliveryRow
        key={delivery._id}
        delivery={delivery}
        rechargeDeliveries={() => setPage(page)}
      />
    );
  };

  return (
    <div className="mgn-top-sm">
      {isLoading ? (
        <TableSkeleton columnCount={8} rowCount={5} />
      ) : !isEmpty(data?.data) ? (
        <>
          <Text
            variant="headingMd"
            tone="supporting"
            className={styles.headerLabel}
          >
            {data?.totalCount || 0}{' '}
            {(data?.totalCount || 0) === 1 ? 'entrega' : 'entregas'}
          </Text>
          {isStackedTableLayout ? (
            <Table.MobileList className={styles.deliveriesMobileList}>
              {data?.data?.map(renderDeliveryRow)}
            </Table.MobileList>
          ) : (
            <div className={styles.deliveriesTableScroll}>
              <Table className={styles.deliveriesTable}>
                <Table.Header>
                  <Table.Row
                    gridTemplateColumns={DELIVERIES_TABLE_GRID_COLUMNS}
                  >
                    <Table.HeaderCell>Código</Table.HeaderCell>
                    <Table.HeaderCell>Loja</Table.HeaderCell>
                    <Table.HeaderCell>Tipo</Table.HeaderCell>
                    <Table.HeaderCell>Entregador</Table.HeaderCell>
                    <Table.HeaderCell>Status</Table.HeaderCell>
                    <Table.HeaderCell>Data de criação</Table.HeaderCell>
                    <Table.HeaderCell>Franquia</Table.HeaderCell>
                    <Table.HeaderCell>Ações</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>{data?.data?.map(renderDeliveryRow)}</Table.Body>
              </Table>
            </div>
          )}
          <div className={styles.pagination}>
            <Pagination
              size="sm"
              limitPerPage={DEFAULT_LIMIT_REQUEST}
              currentPage={page}
              totalCount={data?.totalCount || 0}
              onPageChange={setPage}
            />
          </div>
        </>
      ) : (
        <TableEmptyState
          title="Nenhuma entrega encontrada"
          description="Não encontramos entregas com os filtros selecionados."
        />
      )}

      <footer className="end-page-margin" />

      <JsonView name="Pedidos" source={data} />
    </div>
  );
}
